import React from 'react';

import { FormattedMessageWrappedInSpan } from '../misc';

export default function DvdMsg(props) {
  return <FormattedMessageWrappedInSpan id="messages.dvd" defaultMessage="DVD" />;
}
